import './index.css'
import Navbar from "./components/Navbar";
import {BrowserRouter, Route, Switch} from "react-router-dom";
import Youtube from "./Youtube";

const App = () => {
  return (
      <BrowserRouter>
          <Navbar/>
          <Switch>
              <Route path="/" component={Youtube}/>
          </Switch>
      </BrowserRouter>
  );
}

export default App;
